import React, { useState, useEffect, useRef } from "react";

import Header from "../../Core/Header";
import { Section } from "../../Core/Section";
import { toast } from "react-toastify";
import {
  allProductToSell,
  productList,
  sellApi,
} from "../../Services/Operations/ProductAPI";
import { useSelector } from "react-redux";
import { MdDelete, MdOutlineAirlineSeatIndividualSuite } from "react-icons/md";
import { userListSell, userRole } from "../../Services/Operations/ProductAPI";
import { useLocation } from "react-router-dom";
import { baseURL } from "../../Services/api_endpoints";
import { FaCamera } from "react-icons/fa";
import QrCode from "qrcode-reader";
import { Jimp } from "jimp";

export const Pos = () => {

  const [user, setUser] = useState([]);
  const [commonUserId, setCommonUserId] = useState("");
  const [apiResponse, setApiResponse] = useState([]);
  const [selectedItems, setSelectedItems] = useState([]);
  const location = useLocation();
  const [sellDate, setSellDate] = useState(
    new Date().toISOString().split("T")[0]
  );
  const [paymentMode, setPaymentMode] = useState("");
  const [sellItems, setSellItems] = useState([]);

  const [subTotal, setSubTotal] = useState(0);
  const [grandTotal, setGrandTotal] = useState(0);
  const [totalCgst, setTotalCgst] = useState(0);
  const [totalSgst, setTotalSgst] = useState(0);
  const [totalIgst, setTotalIgst] = useState(0);
  const [payableAmount, setPayableAmount] = useState("");
  const [dueAmount, setDueAmount] = useState("");
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [gstNumber, setGstNumber] = useState("");
  const [name, setName] = useState("");

  const [product, setProduct] = useState([]);
  const [availableProducts, setAvailableProducts] = useState([]);
  const [modal, setModal] = useState(false);
  const [modalItem, setModalItem] = useState(null);
  const token = useSelector((state) => state.user.token);
  const [shouldFetchProducts, setShouldFetchProducts] = useState(false);
  const fileInputRef = useRef(null);
  const [selectedNumbers, setSelectedNumbers] = useState([]);
  const [unSelectedNumbers, setUnSelectedNumbers] = useState([]);
  const [filtered, setFilterd] = useState([]);
  const [searchValue, setSearchValue] = useState("");
  const [selectedImage, setSelectedImage] = useState(null);
  const [match, setMatch] = useState(null);

  const handleCheckboxChange = (e) => {
    const value = e.target.value;

    setSelectedNumbers(
      (prev) =>
        e.target.checked
          ? [...prev, value] // Add to array
          : prev.filter((item) => item !== value) // Remove from array
    );

    console.log(value, selectedNumbers);
  };

  const handleImageChange = async (e) => {
    const file = e.target.files[0];
    if (file) {
      setSelectedImage(file);
      // await  handleUploadQr(file)
    }
  };

  useEffect(() => {
    handleUploadQr(selectedImage);
  }, [selectedImage]);

  const handleImageClick = () => {
    if (fileInputRef.current) {
      fileInputRef.current.click();
    }
  };

  const handleSearch = (e) => {
    setSearchValue(e.target.value);
    if (e.target.value !== "") {
      let list = filtered.filter((item) =>
        item.serialNumber.includes(e.target.value)
      );
      console.log(list);

      setUnSelectedNumbers(list);
      return;
    }
    setUnSelectedNumbers(filtered);
  };

  useEffect(() => {
    const totals = selectedItems.reduce(
      (acc, item) => {
        const qty = item.quantity || 0;
        const price = item.saleRate || 0;
        const saleRate = price * qty;

        let cgst = 0;
        let sgst = 0;
        let igst = 0;
        let tax = 0;

        const gstPercentage = parseFloat(item.productGst) || 0;

        if (gstPercentage > 0) {
          const gstValue = (saleRate * gstPercentage) / 100;

          if (gstNumber?.startsWith("19")) {
            cgst = gstValue / 2;
            sgst = gstValue / 2;
          } else {
            igst = gstValue;
          }
          tax = cgst + sgst + igst;
        }

        acc.totalQty += qty;
        acc.totalAmount += saleRate;
        acc.totalTax += tax;
        acc.totalCgst += cgst;
        acc.totalSgst += sgst;
        acc.totalIgst += igst;
        acc.grandTotal += saleRate + tax;

        return acc;
      },
      {
        totalQty: 0,
        totalAmount: 0,
        totalTax: 0,
        totalCgst: 0,
        totalSgst: 0,
        totalIgst: 0,
        grandTotal: 0,
      }
    );

    setSubTotal(totals.totalAmount);
    setGrandTotal(totals.grandTotal);
    setTotalCgst(totals.totalCgst);
    setTotalSgst(totals.totalSgst);
    setTotalIgst(totals.totalIgst);
    setPayableAmount("");
    setDueAmount("");

    const preparedSellItems = selectedItems.map((item) => {
      const qty = item.quantity || 0;
      const price = item.saleRate || 0;
      const sellPrice = price * qty;

      let cgst = 0;
      let sgst = 0;
      let igst = 0;
      const gstPercentage = parseFloat(item.productGst) || 0;

      if (gstPercentage > 0) {
        const gstValue = (sellPrice * gstPercentage) / 100;

        if (gstNumber?.startsWith("19")) {
          cgst = gstValue / 2;
          sgst = gstValue / 2;
        } else {
          igst = gstValue;
        }
      }

      return {
        productId: item.id,
        sellRate: price,
        quantity: qty,
        sellCgst: cgst / qty || 0,
        sellSgst: sgst / qty || 0,
        sellIgst: igst / qty || 0,
        sellPrice: sellPrice,
        sellCgstAmt: cgst,
        sellSgstAmt: sgst,
        sellIgstAmt: igst,
        taxAmount: cgst + sgst + igst,
      };
    });

    setSellItems(preparedSellItems);
  }, [selectedItems]);

  const selectingSeriaslNumbers = (item) => {
    if (!commonUserId) {
      toast.error("Please select a store owner first!");
      return;
    }
    setModal(true);
    setModalItem(item);
    setUnSelectedNumbers(item.serialNumbers);
    setFilterd(item.serialNumbers);
  };

  const toggleProductInTable = (item) => {
    console.log("selected", item);

    setSelectedItems((prev) => {
      const exists = prev.find((p) => p.productId === item.productId);
      if (exists) {
        return prev.map((p) => {
          if (p.productId === item.productId) {
            if (p.quantity >= p.stock) {
              toast.error("Cannot add more than available stock");
              return p;
            }
            const newQuantity = p.quantity + 1;
            return {
              ...p,
              quantity: newQuantity,
              subtotal:
                newQuantity * (p.purchasePrice || 0) -
                (p.discount || 0) +
                (p.tax || 0),
            };
          }
          return p;
        });
      } else {
        return [
          ...prev,
          {
            ...item,
            quantity: 1,
            discount: 0,
            tax: 0,
            cgst: 0,
            sgst: 0,
            igst: 0,
            subtotal: item.purchasePrice || 0,
          },
        ];
      }
    });
    setModal(false);
  };

  const updateQuantity = (id, change) => {
    setSelectedItems((prev) =>
      prev.map((item) => {
        if (item.id === id) {
          const tentativeQty = item.quantity + change;
          if (tentativeQty < 1) {
            toast.error("Quantity must be at least 1");
            return item;
          }

          if (tentativeQty > item.stock) {
            toast.error("Quantity exceeds available stock");
            return item;
          }

          return {
            ...item,
            quantity: tentativeQty,
            subtotal:
              tentativeQty * (item.saleRate || 0) -
              (item.discount || 0) +
              (item.tax || 0),
          };
        }
        return item;
      })
    );
  };

  const updateField = (id, field, value) => {
    setSelectedItems((prev) =>
      prev.map((item) => {
        if (item.id === id) {
          let updatedValue = value;

          if (field === "quantity") {
            if (value < 1) {
              toast.error("Quantity must be at least 1");
              updatedValue = 1;
            } else if (value > item.stock) {
              toast.error("Quantity exceeds stock");
              updatedValue = item.stock;
            }
          }

          // Recalculate subtotal when price, discount, or tax changes
          const newItem = {
            ...item,
            [field]: updatedValue,
          };

          if (
            ["saleRate", "discount", "tax", "cgst", "sgst", "igst"].includes(
              field
            )
          ) {
            newItem.subtotal =
              (newItem.quantity || 0) * (newItem.saleRate || 0) -
              (newItem.discount || 0) +
              (newItem.tax || 0);
          }

          return newItem;
        }
        return item;
      })
    );
  };

  const deleteItem = (id) => {
    console.log(id);

    let list = selectedItems.filter((item) => item.productId !== id);

    setSelectedItems(list);
    setSelectedImage(null);
  };
  const fetchUserList = async () => {
    try {
      const response = await userListSell(token);
      console.log("user list:", response);
      setUser(response);
    } catch (error) {
      console.error("Error updating profile:", error);
    }
  };

  useEffect(() => {
    const allProductAvailableToSell = async () => {
      try {
        const res = await allProductToSell(token);
        console.log(res);
        if (res.status === 200) {
          setProduct(res.data);
          setAvailableProducts(res.data);
          console.log("setAvailableProducts : ", res.data);
          console.log(selectedNumbers);
        }
      } catch (error) {
        console.log(error);
      }
    };
    allProductAvailableToSell();

    fetchUserList();
  }, [shouldFetchProducts]);

  useEffect(() => {
    const fetchProductList = async () => {
      try {
        const response = await productList(token);
        console.log("response......... : ", response);
        setProduct(response.products);
        // setAvailableProducts(response.products);
      } catch (error) {
        console.error("Error fetching products:", error);
      }
    };

    fetchProductList();
    fetchUserList();
  }, []);

  useEffect(() => {
    if (selectedItems.length > 0) {
      setPayableAmount(0);
      setDueAmount(grandTotal);
    }
  }, [grandTotal]);

  const handleSupplierChange = async (e) => {
    const selectedId = e.target.value;
    console.log("e.target.value: ", e.target.value);
    setCommonUserId(selectedId);

    console.log("selectedId: ", selectedId);
    if (selectedId) {
      try {
        console.log("searching for id: ", selectedId);
        const selectedUser = user.find((u) => u.id === Number(selectedId));
        setName(`${user.firstName} ${user.middleName} ${user.lastName}`);
        console.log("user array: ", user);
        console.log("selectedUser: ", selectedUser);

        if (selectedUser) {
          if (selectedUser.storeOwnerGstNumber) {
            console.log(
              "selectedUser.storeOwnerGstNumber: ",
              selectedUser.storeOwnerGstNumber
            );
            setGstNumber(selectedUser.storeOwnerGstNumber);
          }
        }

        const response = await userRole(selectedId, token);
        console.log("Response for role: ", response);
        setApiResponse(response);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    } else {
      setApiResponse([]);
      setGstNumber("");
    }
  };

  const handlePayment = async () => {
    try {
      if (paymentMode !== "CASH") {
        alert("Online payment is under process");
        return;
      }
    } catch (error) {
      console.log(error);
    }
  };
  const handleSubmit = async () => {
    if (gstNumber?.startsWith("19")) {
      setTotalIgst(0);
    } else {
      setTotalCgst(0);
      setTotalSgst(0);
    }

    if (!commonUserId || !sellDate || selectedItems.length === 0) {
      console.log("commonUserId : ", commonUserId);
      console.log("sellDate : ", sellDate);
      console.log("sellItems : ", sellItems);
      toast.error("Please fill all required fields");
      return;
    }
    console.log("totalCgst : ", totalCgst);
    console.log("totalSgst : ", totalSgst);
    console.log("totalIgst : ", totalIgst);

    const data = {
      commonUserId,
      sellDate,
      subTotal: subTotal.toFixed(2),
      grandTotal: grandTotal.toFixed(2),
      totalCgst: totalCgst.toFixed(2),
      totalSgst: totalSgst.toFixed(2),
      totalIgst: totalIgst.toFixed(2),
      // vendorGstNumber: gstNumber,
      // vendorName :name,
      sellItems: selectedItems.map((item) => ({
        productId: item.productId,
        sellRate: item.saleRate,
        quantity: item.quantity,
        sellCgst: item.productGst / 2,
        sellSgst: item.productGst / 2,
        sellIgst: null,
        sellPrice: item.salePrice + item.tax,
        sellCgstAmt:
          (item.saleRate * item.quantity * item.productGst) / 100 / 2,
        sellSgstAmt:
          (item.saleRate * item.quantity * item.productGst) / 100 / 2,
        sellIgstAmt: "",
        taxAmount: (item.saleRate * item.quantity * item.productGst) / 100,
        serialNumbers: item.serialNumbers
          .filter((i) => selectedNumbers.includes(i.serialNumber))
          .map((i) => i.serialNumber),
      })),
      sellPayments: [
        {
          payableAmount: payableAmount
            ? parseFloat(payableAmount).toFixed(2)
            : 0,
          dueAmount: dueAmount
            ? parseFloat(dueAmount).toFixed(2)
            : grandTotal.toFixed(2),
          paymentMode: paymentMode,
        },
      ],
    };

    console.log("data : ", data);

    try {
      const response = await sellApi(data, token);
      console.log("Sell API Response:", response);

      if (response.status === 200) {
        toast.success("Sale completed successfully");
        setSelectedItems([]);
        setCommonUserId("");
        setSellDate(new Date().toISOString().split("T")[0]);
        setPaymentMode("");
        setSubTotal(0);
        setGrandTotal(0);
        setTotalCgst(0);
        setTotalSgst(0);
        setTotalIgst(0);
        setPayableAmount(0);
        setDueAmount(0);

        setShouldFetchProducts((prev) => !prev);
      } else {
        toast.error(response.data?.message || "Failed to complete sale");
      }
    } catch (error) {
      console.error("Error:", error);
      toast.error("Error completing sale");
    }
  };

  const decodeQrFromUrl = async (url) => {
    const response = await fetch(`${baseURL}api${url}`);
    const blob = await response.blob();
    const buffer = await blob.arrayBuffer();
    const image = await Jimp.read(buffer);

    return new Promise((resolve, reject) => {
      const qr = new QrCode();
      qr.callback = (err, value) => {
        if (err) return reject(err);
        resolve(value?.result);
      };
      qr.decode(image.bitmap);
      console.log("image decode from url 1");
    });
  };

  const decodeQrFromFile = async (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = async (e) => {
        const buffer = e.target.result;
        const image = await Jimp.read(buffer);
        const qr = new QrCode();
        qr.callback = (err, value) => {
          if (err) reject(err);
          else resolve(value?.result);
        };
        qr.decode(image.bitmap);
      };
      reader.readAsArrayBuffer(file);
      console.log("image decode 1");
    });
  };

  const handleUploadQr = async (file) => {
    console.log(file);

    try {
      const uploadedValue = await decodeQrFromFile(file);

      for (let url of filtered) {
        const apiValue = await decodeQrFromUrl(url.qrCodeUrl);
        if (uploadedValue === apiValue) {
          setMatch(url);
          console.log("match with this", url);

          setSelectedNumbers((prev) => [...prev, url.serialNumber]); // Add to array
          toggleProductInTable(modalItem);

          return; // stop once match is found
        } else {
          console.log("not matched");
        }
      }
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <div id="main_content">
      <Header />
      <div className="page po-page">
        <Section />

        {/* ================= TITLE ================= */}
        <div className="po-title-bar">
          <div>
            <h2 className="po-title">Point of Sale</h2>
            <p className="po-title-sub">Pick a store owner, tap a product, choose serial numbers and complete the sale.</p>
          </div>
          <span className="po-title-icon">
            <i className="fa fa-shopping-cart" />
          </span>
        </div>

        <div className="main_part po-main">
          {/* ================= LEFT : BILLING ================= */}
          <div className="left_main_part po-left">
            <div className="po-card">
              <div className="po-card-head">
                <span className="po-card-icon">
                  <i className="fa fa-user" />
                </span>
                <h3>Customer</h3>
              </div>
              <div className="left_input_area po-card-body">
                <div className="left_select_area">
                  <div className="form-group po-field">
                    <label>Store Owner</label>
                    <select value={commonUserId} onChange={handleSupplierChange}>
                      <option value="">-- Select Store Owner--</option>
                      {user.map((user) => (
                        <option key={user.id} value={user.id}>
                          {`${user.firstName} ${user.middleName} ${user.lastName}`}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
              </div>
            </div>

            {/* ---------- Cart ---------- */}
            <div className="po-card">
              <div className="po-card-head">
                <span className="po-card-icon">
                  <i className="fa fa-shopping-basket" />
                </span>
                <h3>Cart</h3>
                <span className="po-count">{selectedItems.length}</span>
              </div>
              <div className="left_view_data_area po-table-wrap">
                <table className="po-table">
                  <thead>
                    <tr>
                      <th>Item</th>

                      <th>Serial Numbers</th>
                      <th>Price</th>
                      <th>GST %</th>

                      <th>CGST</th>
                      <th>SGST</th>

                      <th>IGST</th>

                      <th>Subtotal</th>
                      <th>×</th>
                    </tr>
                  </thead>
                  <tbody>
                    {selectedItems?.map((item) => {
                      const gstPercentage = parseFloat(item.productGst) || 0;
                      const itemTotal =
                        (item.saleRate || 0) * (item.quantity || 0);
                      let cgst = 0;
                      let sgst = 0;
                      let igst = 0;

                      if (gstPercentage > 0) {
                        const gstValue = (itemTotal * gstPercentage) / 100;
                        if (gstNumber === "") {
                          igst = 0;
                          sgst = 0;
                          cgst = 0;
                        } else {
                          if (gstNumber?.startsWith("19")) {
                            cgst = gstValue / 2;
                            sgst = gstValue / 2;
                            igst = 0;
                          } else {
                            sgst = 0;
                            cgst = 0;
                            igst = gstValue;
                          }
                        }
                      }

                      const subtotal =
                        itemTotal - (item.discount || 0) + cgst + sgst + igst;

                      return (
                        <tr key={item.id}>
                          <td className="po-item-name">{item.productName}</td>

                          <td>
                            <div className="po-serials">
                              {item.serialNumbers && item.serialNumbers.length > 0
                                ? item.serialNumbers
                                    .filter((i) =>
                                      selectedNumbers.includes(i.serialNumber)
                                    )
                                    .map((i, k) => (
                                      <p className="po-serial-chip" key={k}>
                                        {" "}
                                        {i.serialNumber}
                                        {"--"}
                                        {i.ear}
                                      </p>
                                    ))
                                : ""}
                            </div>
                          </td>
                          <td>
                            <input
                              type="number"
                              className="po-price-input"
                              value={item.saleRate}
                              onChange={(e) =>
                                updateField(
                                  item.id,
                                  "saleRate",
                                  parseFloat(e.target.value) || 0
                                )
                              }
                            />
                          </td>
                          <td>{item.productGst || 0}</td>

                          <td>{cgst.toFixed(2)}</td>
                          <td>{sgst.toFixed(2)}</td>

                          <td>{igst.toFixed(2)}</td>

                          <td className="po-subtotal">{subtotal.toFixed(2)}</td>
                          <td>
                            <span
                              className="po-delete"
                              onClick={() => deleteItem(item.productId)}
                            >
                              <MdDelete />
                            </span>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
                {selectedItems.length === 0 && (
                  <div className="po-empty">
                    <i className="fa fa-shopping-cart" />
                    <p>Your cart is empty. Tap a product on the right to add it.</p>
                  </div>
                )}
              </div>
            </div>

            {/* ---------- Payment + totals ---------- */}
            <div className="left_footer po-card">
              <div className="po-card-head">
                <span className="po-card-icon">
                  <i className="fa fa-credit-card" />
                </span>
                <h3>Payment</h3>
              </div>
              <div className="po-card-body">
                <div className="po-pay-row">
                  <div className="po-field">
                    <label>Payable amount</label>
                    <input
                      placeholder="Enter Payable amount"
                      value={payableAmount}
                      onChange={(e) => {
                        const value = parseFloat(e.target.value) || 0;
                        if (value > parseFloat(grandTotal)) {
                          toast.error(
                            "Payable amount cannot be greater than Grand Total"
                          );
                          return;
                        }
                        setPayableAmount(value);
                        setDueAmount(grandTotal - value);
                      }}
                    />
                  </div>

                  <div className="po-field">
                    <label>Due amount</label>
                    <input
                      placeholder="Enter Due Amount"
                      value={dueAmount}
                      onChange={(e) => {
                        const value = parseFloat(e.target.value) || 0;
                        if (value > grandTotal) {
                          toast.error(
                            "Due amount cannot be greater than Grand Total"
                          );
                          return;
                        }
                        setDueAmount(value);
                        setPayableAmount(grandTotal - value);
                      }}
                    />
                  </div>
                </div>

                <div className="button_div po-totals">
                  <div className="button_content po-tile">
                    <div className="button_title">Quantity</div>
                    <div className="button_number">
                      {selectedItems.reduce(
                        (sum, item) => sum + (item.quantity || 0),
                        0
                      )}
                    </div>
                  </div>
                  <div className="button_content po-tile">
                    <div className="button_title">Total Amount:</div>
                    <div className="button_number">₹{subTotal.toFixed(2)}</div>
                  </div>
                  <div className="button_content po-tile">
                    <div className="button_title">
                      Total GST: <i className="fa fa-edit" />
                    </div>
                    <div className="button_number">
                      ₹
                      {totalCgst && totalSgst
                        ? (totalCgst + totalSgst).toFixed(2)
                        : totalIgst.toFixed(2)}
                    </div>
                  </div>
                  <div className="button_content po-tile po-tile-hot">
                    <div className="button_title">Grand Total:</div>
                    <div className="button_number">₹{grandTotal.toFixed(2)}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* ================= RIGHT : PRODUCTS ================= */}
          <div className="right_main_part po-right">
            <div className="po-card po-products-card">
              <div className="po-card-head">
                <span className="po-card-icon">
                  <i className="fa fa-cubes" />
                </span>
                <h3>Products</h3>
                <span className="po-count">{availableProducts?.length || 0}</span>
              </div>
              <div className="right_card_div po-products">
                {availableProducts?.map((item) => (
                  <div
                    key={item.id}
                    className={`po-product ${
                      selectedItems.some((i) => i.productId === item.productId)
                        ? "selected is-selected"
                        : ""
                    }`}
                    onClick={() => selectingSeriaslNumbers(item)}
                  >
                    <div className="qty_div po-stock">
                      <div className="qty_div_name">Qty:</div>
                      <div className="qty_div_number">{item.stock}</div>
                    </div>

                    <div className="img_div po-img">
                      {item.productImage ? (
                        <img
                          src={`${baseURL}api${item.productImage}`}
                          alt={item.productName}
                        />
                      ) : (
                        <i className="fa fa-image" />
                      )}
                    </div>

                    <div className="item_type">
                      <p className="po-product-name">{item.productName}</p>
                    </div>

                    <div className="price po-price">
                      <p>₹</p>
                      <p>{item.saleRate}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            {/* ================= SERIAL NUMBER MODAL ================= */}
            {modal && (
              <div className="po-overlay">
                <div className="po-modal">
                  <div className="po-modal-head">
                    <span className="po-modal-icon">
                      <i className="fa fa-barcode" />
                    </span>
                    <div className="po-modal-text">
                      <h3>Select Serials Numbers</h3>
                      <p>{modalItem.productName}</p>
                    </div>
                    <span className="po-modal-close" onClick={() => setModal(false)}>
                      <i className="fa fa-times" />
                    </span>
                  </div>

                  <div className="po-modal-body">
                    <div className="po-scan">
                      <div className="po-camera" onClick={handleImageClick} title="Scan QR from image">
                        <img src="/assets/images/camera.png" />
                        <span>Scan QR</span>
                        <input
                          type="file"
                          ref={fileInputRef}
                          style={{ display: "none" }}
                          onChange={handleImageChange}
                          accept="image/*"
                        />
                      </div>
                      {selectedImage && (
                        <div className="po-preview">
                          <p className="po-preview-x" onClick={() => setSelectedImage(null)}>
                            <i className="fa fa-times" />
                          </p>
                          <img src={URL.createObjectURL(selectedImage)} />
                        </div>
                      )}
                    </div>

                    <div className="po-search">
                      <i className="fa fa-search" />
                      <input
                        placeholder="search number"
                        value={searchValue}
                        onChange={(e) => handleSearch(e)}
                      />
                    </div>

                    <div className="po-serial-list">
                      {unSelectedNumbers.map((num, k) => (
                        <label className="po-serial-row" key={k}>
                          <input
                            type="checkbox"
                            value={num.serialNumber}
                            checked={selectedNumbers.includes(num.serialNumber)}
                            onChange={handleCheckboxChange}
                          />
                          <span className="po-serial-no">{num.serialNumber}</span>
                          <span className="po-serial-ear">{num.ear}</span>
                        </label>
                      ))}
                    </div>

                    <button className="po-select-btn" onClick={() => toggleProductInTable(modalItem)}>
                      <i className="fa fa-check-circle" /> select
                    </button>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>

        {/* ================= SUBMIT ================= */}
        <div className="form-group po-submit-wrap">
          <button className="submit-btn po-submit" onClick={handleSubmit}>
            <i className="fa fa-check-circle" /> Submit
          </button>
        </div>
      </div>
    </div>
  );
};
